const region = "us-east-1"

const staging = {
	appSettingsData: {
		BuyerCognitoGroup: 'wl-nonprod-procurement-portal-buyers',
		SupplierCognitoGroup: 'wl-nonprod-procurement-portal-suppliers',
		federatedIDPProvider: 'wl-stg-procurement-portal-idp'
	},
	amplify_config: {
		Auth: {
			mandatorySignIn: true,
			region: region,
			userPoolId: "us-east-1_ASMtgyz6b",
			userPoolWebClientId: "38al8s913ahqoo6u64o8k1hbbq",
		},
		oauth: {
			domain: "wl-nonprod-procurement-portal.auth.us-east-1.amazoncognito.com",
			scope: [],
			redirectSignIn: "https://wl-stg-procurement-portal.com/login",
			redirectSignOut: "https://wl-stg-procurement-portal.com/login",
			// redirectSignIn: "http://localhost:3000/login",
			// redirectSignOut: "http://localhost:3000/login",
			responseType: "code",
			clientId: "38al8s913ahqoo6u64o8k1hbbq",
		},
		API: {
			endpoints: [
				{
					name: "print",
					endpoint: "https://api.wl-stg-procurement-portal.com/print",
					region: region
				}
			]
		},
	}
};

export default staging;